import React, { useEffect } from 'react';

const SmoothScroll = () => {
  useEffect(() => {
    const handleAnchorClick = (event) => {
      event.preventDefault();

      const targetId = event.currentTarget.getAttribute('href');

      if (targetId === '#') {
        // Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        // Scroll to the target element
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          const targetPosition =
            targetElement.getBoundingClientRect().top + window.scrollY - 100;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      }
    };

    // Wait for the DOM to be fully rendered
    const anchors = document.querySelectorAll('a[href^="#"]');

    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    // Cleanup event listeners on unmount
    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []); // Empty dependency array ensures this runs only once after the component mounts

  return null; // This component doesn't render anything
};

export default SmoothScroll;
